// @flow
export const TARIFF_MONTHLY: 'month_daily' = 'month_daily';
export const TARIFF_FIRST_OF_MONTH: 'first_of_month' = 'first_of_month';
export const TARIFF_DAILY: 'daily' = 'daily';
export const TARIFF_CONSTRUCTOR: 'new' = 'new';
// Bundle -- для внутреннего пользования, в api отсутствует
export const TARIFF_BUNDLE: 'bundle' = 'bundle';
export const TARIFF_EXTERNAL_SYSTEM: 'external' = 'external';
